import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import { observer } from 'owa-mobx-react';
import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import store from '../store/Store';
import { setUserActionState, setUserActionButtonId } from '../actions/setUserAction';
import type RequestState from '../store/schema/RequestState';
import loc from 'owa-localize';
import { Icon } from '@fluentui/react/lib/Icon';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline - Migrating deprecated icons: https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9297/Migrating-deprecated-icons-in-client-web
 *	> 'ControlIcons' import from owa-control-icons is restricted. Use JSX icons from @fluentui/react-icons, otherwise from owa-fluent-icons-svg if they can only be reference by string. */
import { type ControlIcons } from 'owa-control-icons';
import getUserActionTitles from '../selectors/getUserActionTitles';

import {
    checkMarkIcon,
    cancelIcon,
    spinner,
    spinnerCircle,
    dialog,
    dialogTitle,
    dialogContent,
    dialogSubtext,
} from './UserActionDialog.scss';

const LEARNMORE_RESTBLOCKED_ROUTE =
    'https://techcommunity.microsoft.com/t5/exchange-team-blog/top-5-things-that-office-365-admins-should-know-about-findtime/ba-p/1289872';

const UserActionDialog = observer(function UserActionDialog({}) {
    const onDismiss = React.useCallback(() => {
        setUserActionState(0);
    }, [0]);

    const onDismissed = React.useCallback(() => {
        const userActionButtonId = store.userAction.userActionButtonId;
        if (userActionButtonId) {
            const clickedButton = document.getElementById(userActionButtonId);
            if (clickedButton) {
                clickedButton.focus();
            }
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (32,35): Argument of type 'null' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            setUserActionButtonId(null);
        }
    }, [store.userAction.userActionButtonId]);

    const titles = getUserActionTitles();
    var showLearnMoreLink = titles.learnMoreText !== '';

    const { userActionState } = store.userAction;

    let content: JSX.Element;
    switch (userActionState) {
        case 2:
            content = <Icon iconName={'CheckMark'} className={checkMarkIcon} />;
            break;
        case 3:
            content = <Icon iconName={'Cancel'} className={cancelIcon} />;
            break;
        case 1:
            content = (
                <Spinner
                    size={SpinnerSize.large}
                    /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
                     * Causes extra re renders of component
                     *	> JSX attribute values should not contain objects created in the same scope */
                    styles={{ root: spinner, circle: spinnerCircle }}
                />
            );
            break;
        default:
            break;
    }

    return (
        <Dialog
            hidden={userActionState == 0}
            /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
             * Causes extra re renders of component
             *	> JSX attribute values should not contain objects created in the same scope */
            modalProps={{
                isBlocking: userActionState == 1,
            }}
            /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
             * Causes extra re renders of component
             *	> JSX attribute values should not contain objects created in the same scope */
            dialogContentProps={{
                type: DialogType.close,
                className: dialog,
                title: loc(titles.title),
                styles: {
                    title: dialogTitle,
                    content: dialogContent,
                },
            }}
            onDismiss={onDismiss}
            onDismissed={onDismissed}
        >
            {/*// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2454 (81,14): Variable 'content' is used before being assigned.
        // @ts-expect-error */}
            {content}
            <p className={dialogSubtext} role="alert">
                {loc(titles.subText)}
            </p>
            {showLearnMoreLink && (
                <a href={`${LEARNMORE_RESTBLOCKED_ROUTE}`} target="_blank">
                    {loc(titles.learnMoreText)}
                </a>
            )}
        </Dialog>
    );
}, 'UserActionDialog');

export default UserActionDialog;
